import store from "@/store";
const useTranslations = () => {
    return {
        translation: store.getters.rooms.translation
    };
};
export default useTranslations;
